<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Lista de Disciplinas</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row>
          <vs-col>
            <vs-table class="pd-table" striped :data="list">
              <template slot="thead">
                <th width="15%">TURMA</th>
                <th width="30%">DISCIPLINA / CH</th>
                <th width="20%">PERÍODO</th>
                <th width="20%">HORÁRIO</th>
                <th width="15%">VALOR</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  v-for="subject in data"
                  :key="subject.IDTURMADISC"
                  :data="list"
                >
                  <vs-td>
                    {{ subject.IDTURMADISC }} / {{ subject.CODTURMA }} <br />
                    <b>{{ subject.TURMA }}</b>
                  </vs-td>
                  <vs-td> {{ subject.DISCIPLINA }} ({{ subject.CH }}h) </vs-td>
                  <vs-td>
                    <div v-if="subject.DTINICIAL != '1900-01-01T00:00:00'">
                      {{ subject.DTINICIAL | moment }} até
                      {{ subject.DTFINAL | moment }}
                    </div>
                    <div v-else>-</div>
                  </vs-td>
                  <vs-td>
                    {{ offer.MODALIDADE == "D" ? "À Distância" : subject.HORARIO }}
                  </vs-td>
                  <vs-td>
                    <div v-if="subject.VALOR != undefined">
                      R$ {{ subject.VALOR }}
                    </div>
                    <div v-else>-</div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              style="width: 100%; margin: 15px 0 10px 0"
              icon="check_circle"
              @click="proceed()"
            >
              Prosseguir
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-alert
            title="Erro ao tentar criar o atendimento de rematrícula"
            class="margin"
            color="danger"
            v-if="error"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
      </section>
    </div>
    <ConsultValidationRem />
  </div>
</template>

<script>
import Course from "../services/courses";
import ConsultValidationRem from "../components/ConsultValidationRem.vue";
import Mailing from "../services/mailing";
import {
  getStepsInformation,
  updateStepsInformation,
  formatDateToUSA,
} from "../helpers";
import moment from "moment";

export default {
  name: "ListCourseReEnrollment",
  components: {
    ConsultValidationRem
  },
  data: () => ({
    ra: "",
    list: [],
    error: null,
    codAtendimento: [],
    course: null,
    offer: null,
    classData: null,
    electives: null,
  }),

  methods: {
    async proceed() {
      this.$vs.loading({
        color: "danger",
      });

      if (this.course.CODATENDIMENTO == "0") {
        await new Mailing()
          .createReAttendance(
            this.classData.CODCOLIGADA,
            this.course.RA,
            this.offer.IDHABILITACAOFILIAL,
            this.course.ATENDENTEABERTURA,
            this.course.ALUNO,
            this.course.LOCALABERATENDIMENTO
          )
          .then((result) => {
            this.codAtendimento = Array.isArray(result) ? result : [result];
            const codigo = { ...result };

            this.course.CODATENDIMENTO = codigo.data.CODATENDIMENTO;
            this.course.CODCOLIGADA = codigo.data.CODCOLIGADA;
            this.course.CODLOCAL = codigo.data.CODLOCAL;

            const course = this.course;
            updateStepsInformation({
              codAtendimento: codigo.data.CODATENDIMENTO,
              codColigada: codigo.data.CODCOLIGADA,
              codLocal: codigo.data.CODLOCAL,
              course: course,
            });
            this.$router.push("/payment");
          })
          .catch(({ response }) => {
            if (response && response.data) {
              this.error = response.data.error;
            }
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        updateStepsInformation({
          codAtendimento: this.course.CODATENDIMENTO,
          codColigada: this.course.CODCOLIGADA,
          codLocal: this.course.CODLOCAL,
        });
        this.$router.push("/payment");
      }
    },
  },

  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },

  mounted() {
    const { course, offer, classData, electives } = getStepsInformation();
    this.course = course;
    this.offer = offer;
    this.classData = classData;
    this.electives = electives;

    let hasElectives = [];
    let qtd = 0;
    if (electives) {
      this.electives.forEach((element) => {
        qtd = hasElectives.push(element.CODDISC);
      });
    }
    for (let i = qtd; i < 3; i++) {
      hasElectives.push(0);
    }

    this.$vs.loading({
      color: "danger",
    });

    let formatDate = formatDateToUSA(this.course.DATAMINREM);

    new Course()
      .getSubjectsRem(
        this.classData.IDTURMADISC,
        this.classData.CODCURSO,
        this.offer.IDCLASSIFICACAO,
        0,
        this.offer.IDHABILITACAOFILIAL,
        hasElectives[0],
        hasElectives[1],
        hasElectives[2],
        this.course.RA,
        formatDate
      )
      .then(({ data }) => {
        let subjects = [...data];
        updateStepsInformation({ subjects });
        this.list = Array.isArray(data) ? data : [data];

        //somatorio do valor das disciplinas
        let value = this.list.reduce(
          (acum, curr) => acum + (curr.VALOR ? parseFloat(curr.VALOR) : 0),
          0
        );
        //atualiza valor total da rematrícula
        offer.VALOR = value;
        this.offer = offer;
        updateStepsInformation({ offer });
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
};
</script>
